module.exports = __webpack_public_path__ + "static/business-30e9c6074c5223b9a5698c06057c6ba4.jpg";